import gsap from 'gsap'
import * as THREE from 'three'

import vertexShader from '../shaders/tree/vertex.glsl'
import fragmentShader from '../shaders/tree/fragment.glsl'
import Experience from '../Experience.js'

export default class Tree {
  constructor (spheres) {
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.resources = this.experience.resources
    this.time = this.experience.time
    this.debug = this.experience.debug
    this.renderer = this.experience.renderer
    this.camera = this.experience.camera
    this.spheres = spheres
    this.progress = 0.0
    this.distortion = 1
    this.tree = this.resources.items.treeNormeDeg
    this.nbAnim = 0
    this.experience.sizes.on('nextAnimation', () => {
      if (this.nbAnim === 2) return
      this.nbAnim++
      /* if (this.nbAnim === 0) {
        this.focus = this.tree.scene.children[1]
        this.actionCamera1.play()
        this.actionFocus1.play()
      } else */ if (this.nbAnim === 1) {
        // this.focus = this.tree.scene.children[3]
        this.actionCamera2.play()
        this.actionFocus2.play()
      } else if (this.nbAnim === 2) {
        // this.focus = this.tree.scene.children[5]
        this.actionCamera3.play()
        this.actionFocus3.play()
      }
    })
    // Debug

    // Resource
    this.video1First = this.resources.items.video1First
    this.video1End = this.resources.items.video1End

    this.video2First = this.resources.items.video2First
    this.video2End = this.resources.items.video2End
    this.video1 = document.getElementById('video1')

    this.matcapTexture = this.resources.items.matcap

    this.setModel()
    this.getGeometryFromModel(this.tree)
    this.getCamera(this.tree)

    this.playingVideo()
    this.setGUI()
  }

  setGUI () {
    this.debugFolder = this.debug.ui.addFolder('Vortex')
    this.debugFolder.add(this, 'progress').min(0).max(1).step(0.005).onFinishChange(() => { this.material.uniforms.progress.value = this.progress })
    this.debugFolder.add(this, 'distortion').min(0).max(10).step(0.05).onFinishChange(() => { this.material.uniforms.distortion.value = this.distortion })
  }

  setModel () {
    this.planeGeometry = new THREE.PlaneBufferGeometry(648, 648, 648, 648)

    /*   const buffer = this.geometry.attributes.position.array
    this.geometry.attributes.position.array = buffer.slice(0, buffer.length - 138942)
    console.log(this.geometry.attributes.position.array.length) */
    this.material = new THREE.ShaderMaterial({
      side: THREE.DoubleSide,
      transparent: true,
      uniforms: {
        resolution: { type: 'v4', value: new THREE.Vector4() },
        uvRate1: {
          value: new THREE.Vector2(1, 1)
        },
        distortion: { value: 0.0 },
        progress: { value: 0.0 },
        alpha: { value: 1.0 },
        t1: { type: 't', value: this.video1End },
        t2: { type: 't', value: this.video2First },
        time: { value: this.time.elapsed },
        scale: { value: 20.0 }
      },
      vertexShader,
      fragmentShader
    })
    this.plane = new THREE.Points(this.planeGeometry, this.material)

    this.scene.add(this.plane)
  }

  playingVideo () {
    this.video1.play()

    /* const timeUpdate = () => {
      if (this.video1.currentTime !== 0) return
 */
    const timeline = gsap.timeline({ repeatDelay: 2 })
    timeline.to(this.video1.parentNode, {
      duration: 0.1,
      opacity: 0
    }, 1)

    timeline.to(this.material.uniforms.distortion, {
      duration: 2,
      value: 3,
      ease: 'power2.inOut'
    }, 1)

    timeline.to(this.renderer.bloomPass, {
      duration: 2,
      strength: 2.296,
      radius: 0.98,
      threshold: 0,
      ease: 'power2.in'
    }, 1)

    timeline.to(this.material.uniforms.progress, {
      duration: 1,
      value: 1
    }, 2)

    timeline.to(this.video1, {
      duration: 0.1,
      threshold: 0.428,
      opacity: 0,
      ease: 'power2.inOut'
    }, 3)

    timeline.to(this.material.uniforms.distortion, {
      duration: 2,
      value: 0,
      ease: 'power2.inOut'
    }, 3)

    timeline.to(this.renderer.bloomPass, {
      duration: 2,
      strength: 3.236,
      threshold: 0.002,
      radius: 0.93,
      ease: 'power2.inOut'
    }, 3)

    this.spheres.forEach(sphere => {
      timeline.to(sphere.material, {
        duration: 0.1,
        opacity: 1,
        ease: 'power2.inOut'
      }, 4)
    })

    /*  timeline.to(this.material.uniforms.alpha, {
          duration: 1.5,
          value: 0,
          ease: 'power2.inOut'
        }, 5)

        timeline.to(this.treeModel.material, {
          duration: 1.5,
          opacity: 1,
          ease: 'power2.inOut',
          onComplete: () => {
            this.video1First.dispose()
            this.video1End.dispose()
            this.video2First.dispose()
            this.video2End.dispose()
            this.material.dispose()
            this.planeGeometry.dispose()
          }
        }, 5) */
    /*      this.video1.removeEventListener('timeupdate', timeUpdate)
    }

    this.video1.addEventListener('timeupdate', timeUpdate)
 */ }

  getGeometryFromModel (gltfModel) {
    const particleModel = null

    gltfModel.scene.traverse(child => {
      if (child instanceof THREE.Group && child.name === 'tree') {
        this.treeModel = child.children[0]
        const matcapMaterial = new THREE.MeshMatcapMaterial({
          transparent: true,
          opacity: 0.0
        })

        matcapMaterial.matcap = this.matcapTexture

        const initialBufferModel = new Float32Array([...this.treeModel.geometry.attributes.position.array])

        const difference = this.planeGeometry.attributes.position.array.length - initialBufferModel.length

        const newBufferPositions = new Float32Array(initialBufferModel.length + difference)

        for (let i = 0; i < initialBufferModel.length; i++)
          newBufferPositions[i] = initialBufferModel[i]

        for (let i = initialBufferModel.length; i < difference; i++)
          newBufferPositions[i] = initialBufferModel[0]
        this.planeGeometry.setAttribute('modelPosition', new THREE.BufferAttribute(newBufferPositions, 3))

        this.treeModel.material = matcapMaterial
        //   this.treeModel.geometry.scale(0.01, 0.01, 0.01)
        // this.scene.add(this.treeModel)
      }
    })

    return particleModel
  }

  getCamera (gltf) {
    console.log(gltf)
    this.gltf = gltf
    this.focus = gltf.scene.children[5]
    this.mixerCamera = new THREE.AnimationMixer(this.camera.instance)
    //  this.mixerTree = new THREE.AnimationMixer(this.plane)
    this.mixerFocus = new THREE.AnimationMixer(this.focus)
    // this.mixer2 = new THREE.AnimationMixer(this.camera.instance.parent)
    this.actionCamera1 = this.mixerCamera.clipAction(gltf.animations[1])
    this.actionCamera1.setLoop(THREE.LoopOnce)
    this.actionCamera1.clampWhenFinished = true

    this.actionCamera2 = this.mixerCamera.clipAction(gltf.animations[2])
    this.actionCamera2.setLoop(THREE.LoopOnce)
    this.actionCamera2.clampWhenFinished = true

    this.actionCamera3 = this.mixerCamera.clipAction(gltf.animations[4])
    this.actionCamera3.setLoop(THREE.LoopOnce)
    this.actionCamera3.clampWhenFinished = true
    /*
    this.actionTree = this.mixerTree.clipAction(gltf.animations[6])
    this.actionTree.setLoop(THREE.LoopOnce)
    this.actionTree.clampWhenFinished = true */

    // this.camera.controls.target = new THREE.Vector3(0, 0, 0)
    this.actionFocus1 = this.mixerFocus.clipAction(gltf.animations[6])
    this.actionFocus1.setLoop(THREE.LoopOnce)
    this.actionFocus1.clampWhenFinished = true

    this.actionFocus2 = this.mixerFocus.clipAction(gltf.animations[3])
    this.actionFocus2.setLoop(THREE.LoopOnce)
    this.actionFocus2.clampWhenFinished = true

    this.actionFocus3 = this.mixerFocus.clipAction(gltf.animations[5])
    this.actionFocus3.setLoop(THREE.LoopOnce)
    this.actionFocus3.clampWhenFinished = true

    this.camera.instance.lookAt(this.focus)
  }

  update () {
    //  if (this.focus) console.log(this.focus.position)
    //   this.renderer.settings.bloomStrength -=
    // this.material.uniforms.time.value = this.time.elapsed * .0008
    if (this.mixerCamera) this.mixerCamera.update(this.time.delta * .001)
    if (this.mixerFocus) this.mixerFocus.update(this.time.delta * .001)
    if (this.material.uniforms.progress.value >= 1) {
      setTimeout(() => {
        this.actionCamera1.play()
        this.actionFocus1.play()
        this.progress = 0.0
      }, 2000)

    /*   setTimeout(() => {
        this.actionCamera2.play()
        this.actionFocus2.play()

        setTimeout(() => {
          this.actionCamera3.play()
          this.actionFocus3.play()
        }, 4000)
      }, 12000) */
    }
    /*  if (this.action1)
      console.log(this.action1._clip.tracks[0].values[2]) */
    if (this.focus) this.camera.instance.lookAt(this.focus.position)
    // console.log(this.camera.instance.position.z)
    // if (this.mixer2) this.mixer2.update(this.time.delta)
    // this.camera.instance.updateProjectionMatrix()
    // this.material.uniforms.distortion.value = this.distortion
  }
}
